import React from 'react';
import { Box, Heading, Text, Flex } from '@spothero/ui';
import Image from 'common/image';
const PackageInfo = ({ title, description, eventCount }) => {
    const ticketCount = `${eventCount} events in this package`;
    return (<Flex data-testid="PackageInfo">
            <Box bgColor="gray.100" width={{ base: 20, tablet: 24 }} height={{ base: 20, tablet: 24 }} marginRight={4} borderRadius="0.5rem" position="relative" padding={{ base: 3, tablet: 4 }}>
                <Image src="/img/event-packages/event-package-tickets.svg" alt={ticketCount} showLoader={false}/>
                <Box bgColor="gray.dark" borderRadius="full" color="white" position="absolute" top={2} right={2} paddingX={2} variant="body2" data-testid="PackageInfo-count" fontWeight="semibold">
                    {eventCount}
                </Box>
            </Box>
            <Box flex="1">
                <Heading as="h3" variant="h4" marginBottom={1}>
                    {title}
                </Heading>
                <Text marginBottom={{ base: 3, tablet: 4 }} color="gray.dark" fontSize="sm">
                    {description}
                </Text>
            </Box>
        </Flex>);
};
export default PackageInfo;
